export default "__VITE_ASSET__57aaf135__"